"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearButton = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const SimpleButton_1 = tslib_1.__importDefault(require("../../../components/SimpleButton"));
const ClearButton = (props) => {
    return (React.createElement(SimpleButton_1.default, Object.assign({}, props, { className: "ab-StateManagement__Clear-Button", tooltip: "Clear User State" }), props.children));
};
exports.ClearButton = ClearButton;
